import { Component, type ErrorInfo, type ReactNode } from 'react'

/* ===========================================================================
   La red de seguridad.

   Sin esto, cualquier error de render —o un trozo de JavaScript que no llegó
   a bajar con 4G malo— desmonta la raíz y deja la PANTALLA EN BLANCO. En una
   invitación eso es feo; en la noche de la propuesta, con el anillo en el
   bolsillo, es el final de la sorpresa.

   Los estilos van en línea a propósito: si lo que falló fue la descarga de la
   hoja de estilos, este mensaje tiene que verse igual.
   =========================================================================== */

const TINTA = '#14212b'
const BRUMA = '#edefe8'
const PALO = '#c9cec0'

interface Props {
  children: ReactNode
}

interface Estado {
  rompio: boolean
}

export class ErrorBoundary extends Component<Props, Estado> {
  override state: Estado = { rompio: false }

  static getDerivedStateFromError(): Estado {
    return { rompio: true }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // No hay servicio de telemetría: al menos queda en la consola del teléfono
    // para que alguien lo pueda leer conectándolo después.
    console.error('La página se rompió', error, info.componentStack)
  }

  override render(): ReactNode {
    if (!this.state.rompio) return this.props.children

    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          padding: '2rem 1.5rem',
          backgroundColor: TINTA,
          color: BRUMA,
          textAlign: 'center',
          fontFamily: 'Georgia, "Times New Roman", serif',
        }}
      >
        <h1 style={{ fontSize: '1.75rem', lineHeight: 1.2 }}>Algo se rompió.</h1>
        <p style={{ maxWidth: '28rem', color: PALO, lineHeight: 1.6 }}>
          Vuelve a cargar la página. Nada de lo que hiciste se perdió.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            minHeight: '52px',
            padding: '0 2rem',
            borderRadius: '999px',
            border: 'none',
            backgroundColor: BRUMA,
            color: TINTA,
            fontSize: '1rem',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Volver a cargar
        </button>
      </div>
    )
  }
}
